import { Box } from '@material-ui/core';
import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'context';
import { useClosureById } from 'hooks';
import { ClosureForm, SortingCenterContractsEditFormPutBatch } from 'types';
import Loading from 'components/Loading';
import { ClosureContext } from 'pages/Closures/ClosureClose';
import { formatSortingCenterContractsBeforePut } from 'utils/normalizer';
import { putSortingCenterContracts } from 'services/apiOperations';
import { FormStepComponentProps } from '../MultiStepForm';
import { notify } from '../../Notifier';
import SortingCenterContractsEditForm from '../SortingCenterContractsEditForm';

const StepSortingCenterContract: React.FC<FormStepComponentProps<ClosureForm, ClosureContext>> = ({
  onSubmit,
  formName,
  previousStepData,
}) => {
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const sortingCenter = context.getSortingCenter?.();
  const closureId = previousStepData.closureId ?? '';
  const [closure] = useClosureById(closureId);

  const { handleSubmit } = useForm<ClosureForm>({
    mode: 'onBlur',
  });

  if (!closure) return <Loading />;

  const onSubmitSortingCenterContractForm = async (
    sortingCenterContractsEditForm: SortingCenterContractsEditFormPutBatch,
  ) => {
    if (!sortingCenter) return;
    try {
      await putSortingCenterContracts(
        formatSortingCenterContractsBeforePut(sortingCenterContractsEditForm),
        sortingCenter['@id'],
      );
      handleSubmit(onSubmit)();
    } catch (e) {
      notify({
        message: t('errorGeneric'),
        severity: 'error',
      });
    }
  };

  return (
    <Box px={8}>
      <SortingCenterContractsEditForm
        formName={formName}
        closure={closure}
        onSubmit={onSubmitSortingCenterContractForm}
      />
    </Box>
  );
};

export default StepSortingCenterContract;
